import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

const PROD_API_ORIGIN = 'https://api.wedmin.biz';
const LOCAL_API_ORIGIN = 'http://localhost:4040';

const isLocalRuntime = () => {
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
};

const rewriteApiOrigin = (url: string) => {
  if (!isLocalRuntime()) return url;
  if (!url.startsWith(PROD_API_ORIGIN)) return url;
  return `${LOCAL_API_ORIGIN}${url.slice(PROD_API_ORIGIN.length)}`;
};

const patchFetchForLocalApi = () => {
  const originalFetch = window.fetch.bind(window);

  window.fetch = (async (input: RequestInfo | URL, init?: RequestInit) => {
    if (typeof input === 'string') {
      return originalFetch(rewriteApiOrigin(input), init);
    }

    if (input instanceof URL) {
      return originalFetch(rewriteApiOrigin(input.toString()), init);
    }

    const rewrittenUrl = rewriteApiOrigin(input.url);
    if (rewrittenUrl === input.url) {
      return originalFetch(input, init);
    }

    const rewrittenRequest = new Request(rewrittenUrl, input);
    return originalFetch(rewrittenRequest, init);
  }) as typeof window.fetch;
};

patchFetchForLocalApi();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
